import { environmentConfig } from "@src/appV2/environment";

export const FRIENDS_ENDPOINT = (workerId: string) =>
  `${environmentConfig.REACT_APP_BASE_API_URL}/v2/workers/${workerId}`;
